import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IError } from '../ServerApi/types/IError';
import { RefreshModeTypes } from '../ServerApi/types/IRemoteRefreshProperties';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';

export class ChangeDatasourceRefreshModeAction {

  public static $inject = ['$translate', 'DataSources'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private DataSources: DataSources) { }

  public execute(datasource: IDataSourceBase, newRefreshMode: string, currentRemoteAgentName: string, suppressSuccessToast: boolean, suppressErrorToast: boolean): ng.IPromise<IResult> {
    return this.DataSources.setRefreshMode(datasource.id, newRefreshMode).then((result: IResult) => {
      if (!suppressErrorToast && result.errors && result.errors.length) {
        ToasterService.instance.pop({type: ToastType.Error, text: this.errorMessageFor(result.errors[0], datasource)});
      }

      if (!suppressSuccessToast && (!result.errors || !result.errors.length)) {
        if (newRefreshMode === RefreshModeTypes.Remote) {
          ToasterService.instance.pop({
            type: ToastType.Info,
            text: this.$translate.instant('editRemoteRefreshPropertiesAgentSuccess', { AGENT_NAME: L10n.elideIfLong(currentRemoteAgentName) })
          });
        } else {
          ToasterService.instance.pop({ type: ToastType.Info, text: this.$translate.instant('editRemoteRefreshPropertiesServerSuccess') });
        }
      }

      return result;
    });

  }

  private errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      case CommonErrorCode.DatasourceNotFound:
        return this.$translate.instant('errorDatasourceNotFound', { DATASOURCE_NAME: L10n.elideIfLong(datasource.name) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangeDatasourceRefreshModeAction', ChangeDatasourceRefreshModeAction);
